/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { GridOptions } from 'ag-grid-community';
import { isFunction, isNil } from 'lodash';
import { createGridOptions, GridModel } from '../state/grid-state.interfaces';
import { LayoutBasedGridDefinition } from './layout-based-grid-definition';
import { ManualGridDefinition } from './manual-grid-definition';

export interface GridModelSupport {
  readonly model: GridModel;

  buildGridModel?(): GridModel;
}

export abstract class ManualGridDefinitionWithModel extends ManualGridDefinition implements GridModelSupport {
  private _model?: GridModel;

  get model(): GridModel {
    if (isNil(this._model)) {
      throw new Error('GridModel is not defined');
    }

    return this._model;
  }

  build(): GridOptions {
    const model = this._model = isFunction(this.buildGridModel) ? this.buildGridModel() : void 0;
    return model ? { ...super.build(), ...createGridOptions(model) } : super.build();
  }

  abstract buildGridModel(): GridModel;
}

// tslint:disable-next-line:max-line-length
export abstract class LayoutBasedGridDefinitionWithModel extends LayoutBasedGridDefinition implements GridModelSupport {
  private _model?: GridModel;

  get model(): GridModel {
    if (isNil(this._model)) {
      throw new Error('GridModel is not defined');
    }

    return this._model;
  }

  build(): GridOptions {
    const model = this._model = isFunction(this.buildGridModel) ? this.buildGridModel() : void 0;
    return model ? { ...super.build(), ...createGridOptions(model) } : super.build();
  }

  abstract buildGridModel(): GridModel;
}
